import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { SaveOutlined, PrinterOutlined } from '@ant-design/icons';
import { Line, Bar } from 'react-chartjs-2';
import * as Styled from './Charts.styles';
import { openPrintDialog } from '../SideBar/actions';
import { selectors } from '../SideBar/reducer';
import CHART_SETTINGS from './constants';

const Charts = ({ title, data, options, link, download, scales }) => {
  const chartRef = useRef();
  const dispatch = useDispatch();

  const printDialogOpen = useSelector(selectors.printDialogOpen);

  return (
    <Styled.ChartsBlockWrapper>
      <Styled.ChartContentWrapper ref={chartRef}>
        <Styled.ChartHeader>
          {title && <Styled.ChartTitle>{title}</Styled.ChartTitle>}
          <div className="controls__wrapper">
            {!printDialogOpen && (
              <>
                <a href={download}>
                  <Styled.ChartControl>
                    <SaveOutlined />
                  </Styled.ChartControl>
                </a>
                <Styled.ChartControl onClick={() => dispatch(openPrintDialog(true))}>
                  <PrinterOutlined />
                </Styled.ChartControl>
              </>
            )}
          </div>
        </Styled.ChartHeader>

        <Link to={`/charts/${link}`}>
          {link[0] !== 'MARKET_TOTAL_AND_AS_PERCENT_OF_TOTAL_ASSETS' ? (
            <Line data={data} options={{ ...CHART_SETTINGS.options, ...options, scales }} />
          ) : (
            <Bar data={data} options={{ ...CHART_SETTINGS.options, ...options, scales }} />
          )}
        </Link>
      </Styled.ChartContentWrapper>
    </Styled.ChartsBlockWrapper>
  );
};

Charts.propTypes = {
  title: PropTypes.string,
  link: PropTypes.string,
  download: PropTypes.string,
  data: PropTypes.shape({}).isRequired,
  options: PropTypes.shape({}).isRequired,
  scales: PropTypes.shape({}),
};

Charts.defaultProps = {
  title: null,
  link: null,
  download: null,
  scales: null,
};

export default Charts;
